export default "__VITE_ASSET__DUT$9E5h__"